import "./stats.css";
import { Rate, Select, Skeleton } from "antd";
import Header from "../../Components/header";
import DividerImage from "../../../assets/vectors/divider.png";
import FormatHelper from "../../../Helper/FormatHelper";
import FillStar from "../../../assets/vectors/fill-star.png";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ReactApexChart from "react-apexcharts";
import MessageArrowIcon from "../../../assets/icons/message_arrow";
import DoubleTick from "../../../assets/icons/double_tick";
import { useEffect, useState } from "react";
import useUser from "../../../hooks/useUser";
import { useSelector } from "react-redux";
import moment from "jalali-moment";
import useSurvey from "../../../hooks/useSurvey";
import GaugeChart from "react-gauge-chart";
import Layout from "../../../layout";

const { Option } = Select;

const Stats = () => {
  const { getUserStats, userStats, userLoading } = useUser();

  const { getSurveys, surveyData } = useSurvey();

  // const [chartOptions, setChartOptions] = useState({
  const chartOptions = {
    chart: {
      height: 200,
      type: "radialBar",
    },
    plotOptions: {
      colors: ["#1e5279", "#1e5279", "#1e5279"],
      radialBar: {
        hollow: {
          size: "50%",
        },
        track: {
          strokeWidth: "100%",
          margin: 0, // margin is in pixels
          background: "rgba(220,220,220,1)", // Change this to your desired tracker color
          colors: ["#1e5279"], // Change this to your desired tracker color
        },
        dataLabels: {
          value: {
            fontSize: "18px",
            fontFamily: "IranSansBold",
            offsetY: -10,
            formatter: function (val) {
              return "% " + FormatHelper.toPersianString(val);
            },
          },
        },
      },
    },
    labels: [""],
  }
  // });

  const [selectedService, setSelectedService] = useState(null);

  const profileData = useSelector((state) => state.TechAppReducer.profileData);

  useEffect(() => {
    getSurveys();
  }, []);

  useEffect(() => {
    if (profileData?.services?.data[0]?.id) {
      getUserStats(profileData?.id, profileData?.services?.data[0]?.id);
      setSelectedService(profileData?.services?.data[0]?.id.toString());
    }
  }, [profileData]);

  return (
    <Layout>
      <div className="stats">
        <Header title={"اطلاعات و آمار تکنسین"} />
        <div className="stats_body">
          {/* service select */}
          <div className="stats_select">
            <Select
              onChange={(value) => {
                getUserStats(profileData?.id, value);
                setSelectedService(value);
              }}
              value={selectedService}
              placeholder="سرویس مورد نظر را انتخاب کنید"
            >
              {profileData?.services?.data?.map((service, index) => (
                <Option
                  key={index}
                  style={{ textAlign: "right" }}
                  value={service.id.toString()}
                >
                  {service.title}
                </Option>
              ))}
            </Select>
            <img src={DividerImage} alt="divider" />
          </div>
          {userLoading?.getUserStats ? (
            <div className="stats_loadings">
              <Skeleton.Button
                style={{
                  width: "100%",
                  height: "320px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
                shape={"square"}
                active
              />
              <Skeleton.Button
                style={{
                  width: "100%",
                  height: "278px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
                shape={"square"}
                active
              />
              <Skeleton.Button
                style={{
                  width: "100%",
                  height: "278px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
                shape={"square"}
                active
              />
              <Skeleton.Button
                style={{
                  width: "100%",
                  height: "278px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
                shape={"square"}
                active
              />
            </div>
          ) : userStats ? (
            <div className="stats_cards">
              {/* orders stats */}
              <div className="stats_card">
                <div>آمار سفارشات</div>
                <div className="orders_stat">
                  <div>
                    <div>
                      <div>تعداد کل سفارش ارجاع شده</div>
                      <div></div>
                      <div>
                        {userStats?.count_refer
                          ? FormatHelper.toPersianString(userStats?.count_refer)
                          : "۰"}
                      </div>
                    </div>
                    <div>
                      <div>تعداد سفارشات ارجاع شده اختصاصی</div>
                      <div></div>
                      <div>
                        {userStats?.count_private
                          ? FormatHelper.toPersianString(
                              userStats?.count_private
                            )
                          : "۰"}
                      </div>
                    </div>
                    <div>
                      <div>تعداد سفارش قبول شده</div>
                      <div></div>
                      <div>
                        {userStats?.count_accept
                          ? FormatHelper.toPersianString(
                              userStats?.count_accept
                            )
                          : "۰"}
                      </div>
                    </div>
                    <div>
                      <div>تعداد سفارش انجام شده</div>
                      <div></div>
                      <div>
                        {userStats?.count_done
                          ? FormatHelper.toPersianString(userStats?.count_done)
                          : "۰"}
                      </div>
                    </div>
                    <div>
                      <div>تعداد سفارش برگشتی</div>
                      <div></div>
                      <div>
                        {userStats?.count_returned
                          ? FormatHelper.toPersianString(
                              userStats?.count_returned
                            )
                          : "۰"}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>میزان درآمد شما</div>
                    <div></div>
                    <div>
                      <span>تومان</span>
                      <div>
                        {userStats?.technician_income
                          ? FormatHelper.toPersianString(
                              FormatHelper.numberSeperator(
                                userStats?.technician_income
                              )
                            )
                          : "۰"}
                      </div>
                    </div>
                  </div>
                  {/* date nav */}
                  <div className="stat_card_date_nav">
                    <div>
                      {/* <IoIosArrowForward style={{ marginLeft: 3 }} />
                    <span>
                      {moment()
                        .locale("fa")
                        .subtract(1, "months")
                        .format("MMMM")}
                    </span> */}
                    </div>
                    <div>
                      {moment()
                        .locale("fa")
                        .subtract(1, "months")
                        .format("MMMM")}{" "}
                      {FormatHelper.toPersianString(
                        moment().locale("fa").format("YYYY")
                      )}
                    </div>
                    <div>
                      {/* <span>
                      {moment().locale("fa").add(1, "months").format("MMMM")}
                    </span>
                    <IoIosArrowBack style={{ marginRight: 3 }} /> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* scores stats */}
              <div className="stats_card">
                <div>میانگین امتیاز مشتری در کل طول فعالیت</div>
                <div className="scores_stat">
                  <div>
                    <div>
                      <Rate
                        allowHalf
                        value={
                          surveyData?.points?.overall !== null &&
                          surveyData?.points?.overall !== undefined
                            ? parseFloat(
                                Math.round(surveyData?.points?.overall * 2) / 2
                              )
                            : 0
                        }
                      />
                      <div>
                        {surveyData?.points?.overall !== null &&
                        surveyData?.points?.overall !== undefined
                          ? FormatHelper.toPersianString(
                              Math.round(surveyData?.points?.overall * 2) / 2
                            )
                          : "---"}
                      </div>
                    </div>
                    {/* <div>(از {FormatHelper.toPersianString(53)} نظر)</div> */}
                  </div>
                  <div>
                    <div>
                      <div>رفتار</div>
                      <div>
                        <div
                          style={{
                            width: `${
                              surveyData?.points?.behavior
                                ? parseFloat(
                                    Math.round(
                                      surveyData?.points?.behavior * 2
                                    ) / 2
                                  ) * 20
                                : 0
                            }%`,
                          }}
                        ></div>
                      </div>
                      <div>
                        <img src={FillStar} alt="score" />
                        <div>
                          {surveyData?.points?.behavior
                            ? FormatHelper.toPersianString(
                                Math.round(surveyData?.points?.behavior * 2) / 2
                              )
                            : "۰"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>تخصص</div>
                      <div>
                        <div
                          style={{
                            width: `${
                              surveyData?.points?.skill
                                ? parseFloat(
                                    Math.round(surveyData?.points?.skill * 2) /
                                      2
                                  ) * 20
                                : 0
                            }%`,
                          }}
                        ></div>
                      </div>
                      <div>
                        <img src={FillStar} alt="score" />
                        <div>
                          {surveyData?.points?.skill
                            ? FormatHelper.toPersianString(
                                Math.round(surveyData?.points?.skill * 2) / 2
                              )
                            : "۰"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>هزینه دریافتی</div>
                      <div>
                        <div
                          style={{
                            width: `${
                              surveyData?.points?.fair_price
                                ? parseFloat(
                                    Math.round(
                                      surveyData?.points?.fair_price * 2
                                    ) / 2
                                  ) * 20
                                : 0
                            }%`,
                          }}
                        ></div>
                      </div>
                      <div>
                        <img src={FillStar} alt="score" />
                        <div>
                          {surveyData?.points?.fair_price
                            ? FormatHelper.toPersianString(
                                Math.round(surveyData?.points?.fair_price * 2) /
                                  2
                              )
                            : "۰"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>حضور به موقع</div>
                      <div>
                        <div
                          style={{
                            width: `${
                              surveyData?.points?.ontime
                                ? parseFloat(
                                    Math.round(surveyData?.points?.ontime * 2) /
                                      2
                                  ) * 20
                                : 0
                            }%`,
                          }}
                        ></div>
                      </div>
                      <div>
                        <img src={FillStar} alt="score" />
                        <div>
                          {surveyData?.points?.ontime
                            ? FormatHelper.toPersianString(
                                Math.round(surveyData?.points?.ontime * 2) / 2
                              )
                            : "۰"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* orders stats */}
              <div className="stats_card">
                <div>میزان قبول / انجام سفارشات</div>
                <div className="stats_chart">
                  <div>
                    <div>
                      <ReactApexChart
                        options={chartOptions}
                        series={[
                          userStats?.rate_accept ? userStats?.rate_accept : 0,
                        ]}
                        type="radialBar"
                        height={200}
                      />
                      <div className="stats_chart_single">
                        <div>نرخ قبول سفارش</div>
                        <MessageArrowIcon />
                      </div>
                    </div>
                    <div>
                      <ReactApexChart
                        options={chartOptions}
                        series={[
                          userStats?.rate_done ? userStats?.rate_done : 0,
                        ]}
                        type="radialBar"
                        height={200}
                      />
                      <div className="stats_chart_single">
                        <div>نرخ انجام سفارش</div>
                        <DoubleTick />
                      </div>
                    </div>
                  </div>
                </div>
                {/* date nav */}
                <div className="stat_card_date_nav">
                  <div>
                    {/* <IoIosArrowForward style={{ marginLeft: 3 }} />
                    <span>
                      {moment()
                        .locale("fa")
                        .subtract(1, "months")
                        .format("MMMM")}
                    </span> */}
                  </div>
                  <div>
                    {moment().locale("fa").subtract(1, "months").format("MMMM")}{" "}
                    {FormatHelper.toPersianString(
                      moment().locale("fa").format("YYYY")
                    )}
                  </div>
                  <div>
                    {/* <span>
                      {moment().locale("fa").add(1, "months").format("MMMM")}
                    </span>
                    <IoIosArrowBack style={{ marginRight: 3 }} /> */}
                  </div>
                </div>
              </div>
              {/* orders stats */}
              <div className="stats_card">
                <div>میزان مبلغ دریافتی و سوددهی</div>
                <div className="stats_chart">
                  <div className="stats_guages">
                    {/* percent_avg_received_this */}
                    <div>
                      <GaugeChart
                        id="gauge-chart2"
                        nrOfLevels={5}
                        percent={[
                          userStats?.percent_avg_received_this
                            ? userStats?.percent_avg_received_this > 100
                              ? 1
                              : userStats?.percent_avg_received_this / 100
                            : 0,
                        ]}
                        formatTextValue={(value) => {
                          return "";
                        }}
                        colors={[
                          "#d10007",
                          "#e65e5e",
                          "#edaa00",
                          "#ffee00",
                          "#09b300",
                        ]}
                      />
                      {userStats?.percent_avg_received_this >= 0 &&
                      userStats?.percent_avg_received_this <= 20 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#d10007",
                          }}
                        >
                          خیلی کم و بسیار نامناسب
                        </div>
                      ) : null}
                      {userStats?.percent_avg_received_this > 20 &&
                      userStats?.percent_avg_received_this <= 80 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#e65e5e",
                          }}
                        >
                          کم و نامناسب
                        </div>
                      ) : null}
                      {userStats?.percent_avg_received_this > 80 &&
                      userStats?.percent_avg_received_this <= 110 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#edaa00",
                          }}
                        >
                          متوسط
                        </div>
                      ) : null}
                      {userStats?.percent_avg_received_this > 110 &&
                      userStats?.percent_avg_received_this <= 200 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#ffee00",
                          }}
                        >
                          بالا
                        </div>
                      ) : null}
                      {userStats?.percent_avg_received_this > 200 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#09b300",
                          }}
                        >
                          بسیار بالا
                        </div>
                      ) : null}
                      <div className="stats_chart_double">
                        <div>میانگین دریافت هزینه از مشتری</div>
                      </div>
                    </div>
                    {/* percent_avg_netprofit_this */}
                    <div>
                      <GaugeChart
                        id="gauge-chart2"
                        nrOfLevels={5}
                        percent={[
                          userStats?.percent_avg_netprofit_this
                            ? userStats?.percent_avg_netprofit_this > 100
                              ? 1
                              : userStats?.percent_avg_netprofit_this / 100
                            : 0,
                        ]}
                        formatTextValue={(value) => {
                          return "";
                        }}
                        colors={[
                          "#d10007",
                          "#e65e5e",
                          "#edaa00",
                          "#75d990",
                          "#09b300",
                        ]}
                      />
                      {userStats?.percent_avg_netprofit_this >= 0 &&
                      userStats?.percent_avg_netprofit_this <= 10 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#d10007",
                          }}
                        >
                          خیلی کم
                        </div>
                      ) : null}
                      {userStats?.percent_avg_netprofit_this > 10 &&
                      userStats?.percent_avg_netprofit_this <= 20 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#e65e5e",
                          }}
                        >
                          کم
                        </div>
                      ) : null}
                      {userStats?.percent_avg_netprofit_this > 20 &&
                      userStats?.percent_avg_netprofit_this <= 40 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#edaa00",
                          }}
                        >
                          متوسط
                        </div>
                      ) : null}
                      {userStats?.percent_avg_netprofit_this > 40 &&
                      userStats?.percent_avg_netprofit_this <= 50 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#75d990",
                          }}
                        >
                          خوب
                        </div>
                      ) : null}
                      {userStats?.percent_avg_netprofit_this > 50 &&
                      userStats?.percent_avg_netprofit_this <= 100 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#09b300",
                          }}
                        >
                          عالی
                        </div>
                      ) : null}
                      <div className="stats_chart_double">
                        <div>میزان سود از دریافتی تکنسین از مشتری</div>
                      </div>
                    </div>
                    {/* percent_spending_this */}
                    <div>
                      <GaugeChart
                        id="gauge-chart2"
                        nrOfLevels={5}
                        percent={[
                          userStats?.percent_spending_this
                            ? userStats?.percent_spending_this > 100
                              ? 1
                              : userStats?.percent_spending_this / 100
                            : 0,
                        ]}
                        formatTextValue={(value) => {
                          return "";
                        }}
                        colors={[
                          // start
                          "#09b300",
                          "#75d990",
                          "#edaa00",
                          "#e65e5e",
                          "#d10007",
                        ]}
                      />
                      {userStats?.percent_spending_this >= 0 &&
                      userStats?.percent_spending_this <= 50 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#09b300",
                          }}
                        >
                          عالی
                        </div>
                      ) : null}
                      {userStats?.percent_spending_this > 50 &&
                      userStats?.percent_spending_this <= 80 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#75d990",
                          }}
                        >
                          خوب
                        </div>
                      ) : null}
                      {userStats?.percent_spending_this > 80 &&
                      userStats?.percent_spending_this <= 100 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#edaa00",
                          }}
                        >
                          متوسط
                        </div>
                      ) : null}
                      {userStats?.percent_spending_this > 100 &&
                      userStats?.percent_spending_this <= 150 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#e65e5e",
                          }}
                        >
                          نامناسب
                        </div>
                      ) : null}
                      {userStats?.percent_spending_this > 150 &&
                      userStats?.percent_spending_this <= 1000 ? (
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: 8,
                            fontFamily: "IranSansBold",
                            color: "#d10007",
                          }}
                        >
                          بسیار نامناسب
                        </div>
                      ) : null}
                      <div className="stats_chart_double">
                        <div>وضعیت مبلغ خرج کرد شما در سفارشات</div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* date nav */}
                <div className="stat_card_date_nav">
                  <div>
                    {/* <IoIosArrowForward style={{ marginLeft: 3 }} />
                    <span>
                      {moment()
                        .locale("fa")
                        .subtract(1, "months")
                        .format("MMMM")}
                    </span> */}
                  </div>
                  <div>
                    {moment().locale("fa").subtract(1, "months").format("MMMM")}{" "}
                    {FormatHelper.toPersianString(
                      moment().locale("fa").format("YYYY")
                    )}
                  </div>
                  <div>
                    {/* <span>
                      {moment().locale("fa").add(1, "months").format("MMMM")}
                    </span>
                    <IoIosArrowBack style={{ marginRight: 3 }} /> */}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </Layout>
  );
};
export default Stats;
